import * as API from 'common/constant/routes'
import { postJson, getJson } from 'helper/http'

export const generateReport = (options) => postJson(API.GENERATE_REPORT, {}, options)
export const login = () => postJson(API.NPRINTING_LOGIN, {}, {})
export const checkReportStatus = (requestId) => getJson(API.CHECK_REPORT_STATUS, {}, { requestId })
export const getReportResult = (requestId) => getJson(API.GET_REPORT_RESULT, {}, { requestId })
export const getUsersRequests = (mp) => getJson(API.GET_USERS_REQUESTS, {}, { mp })
export const getDownloadUrl = (key) => getJson(API.GET_DOWNLOAD_URL, {}, { key })
export const getCampaigns = (mp) => getJson(API.GET_CAMPAIGNS, {}, { mp })
